import { getBonuses } from '@/http/bonusesApi';
import { getBonusesQueryKey } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetBonusesQuery = () => {
  return useQuery({
    queryKey: getBonusesQueryKey(),
    queryFn: () => getBonuses(),
    select: (response) => response.data.data,
  });
};
